<script lang='ts'>
import { reactive, defineComponent, computed, watch } from '@vue/composition-api';
import * as productsStoreModule from '@/store/main/Products';

interface IProps {
    productSlug: string;
    itemName: string;
    itemUrl: string;
}

const AppHeaderBreadcrumb = defineComponent({
    name: 'AppHeaderBreadcrumb',
    props: {
        productSlug: String,
        itemName: String,
        itemUrl: String,
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const productsStore = productsStoreModule.useProductsStore();

        const state = reactive({
            product: computed(() => productsStore.state.products.find((x) => x.slug === props.productSlug)),
        });

        watch(
            state.product,
            () => {
                if (state.product != null) {
                    productsStore.dispatch(new productsStoreModule.ChangeCurrentProduct(state.product.slug));
                }
            },
            { immediate: true }
        );

        return {
            state,
        };
    },
});

export default AppHeaderBreadcrumb;
</script>

<template>
  <div v-if="state.product != null" style="font-size: 12px;" class="font-weight-regular">
    <router-link to="/products" class="blueGrey90Light--text">
      Products
    </router-link>
    >
    <router-link :to="`/${productSlug}/dashboard`" class="blueGrey90Light--text">
      {{ state.product.name }}
    </router-link>

    <template v-if="itemUrl">
      >
      <router-link :to="itemUrl" class="blueGrey90Light--text">
        {{ itemName }}
      </router-link>
    </template>
  </div>
</template>

<style lang='scss' scoped></style>